class TimezoneService {
    private timezoneCache: any[] | null = null;

    // Method to get all timezones
    async getAllTimezones(): Promise<any[]> {
      if (this.timezoneCache) {
        return this.timezoneCache;
      }

      try {
        const response = await fetch("/data/timezones.json");
        if (!response.ok) {
          throw new Error("Failed to fetch timezones data");
        }
        const data: any[] = await response.json();
        this.timezoneCache = data;
        return this.timezoneCache || [];
      } catch (error) {
        console.error("Error fetching timezones data:", error);
        return [];
      }
    }
  }
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default new TimezoneService();